module.exports = __webpack_public_path__ + "img/Ja, ik.9d6aa9c9.png";